import { entriesOf } from "utils/general";

export function buildFormData(record: Record<string, any>) {
  const formData = new FormData();
  entriesOf(record).forEach(([name, value]) => {
    formData.append(name, value);
  });
  return formData;
}
